import { UpsellStep } from "@redotech/redo-model/advanced-flow/steps";
import { FrontendStepType, PartialWithRequiredType } from ".";
import { UpsellInspector } from "./inspectors/upsell-inspector";

export const upsellStepType: FrontendStepType<
  PartialWithRequiredType<UpsellStep>
> = {
  valid: (step) => true,
  type: "standard",
  inspectorFactory: (outerProps) => ({
    header: { title: outerProps.step.name ?? "Upsell" },
    sections: [
      {
        fields: [
          { path: "name", label: "Upsell name", widget: "text" },
          {
            path: "upsellId",
            label: "",
            widget: "custom",
            Element: (props) => {
              return (
                <UpsellInspector
                  doSave={outerProps.save}
                  upsellId={props.value.upsellId ?? ""}
                />
              );
            },
          },
        ],
      },
    ],
  }),
};
